import { QueryParams } from './types/QueryParams';

export const getFullUrl = (url: string, queryParams: QueryParams): string => {
    if (!Object.keys(queryParams).length) {
        return url;
    }
    const searchParams = new URLSearchParams(queryParams);
    return `${url}?${searchParams.toString()}`;
};
